import Vue from "vue";
import Vuetify from "vuetify/lib";

const icons = {
  complete: "01",
  cancel: "las la-times-circle",
  close: "las la-times",
  delete: "las la-minus-circle",
  clear: "las la-times",
  success: "las la-check",
  info: "las la-info-circle",
  warning: "las la-exclamation-circle",
  error: "las la-exclamation-triangle",
  prev: "las la-angle-left",
  next: "las la-angle-right",
  checkboxOn: "lar la-check-circle",
  checkboxOff: "las la-circle",
  checkboxIndeterminate: "10",
  delimiter: "11", // for carousel
  sort: "las la-sort-down",
  expand: "13",
  menu: "14",
  subgroup: "15",
  dropdown: "las la-angle-down",
  radioOn: "lar la-check-circle",
  radioOff: "las la-circle",
  edit: "las la-edit",
  ratingEmpty: "20",
  ratingFull: "21",
  ratingHalf: "22",
  loading: "23",
  first: "24",
  last: "25",
  unfold: "26",
  file: "27"
};

Vue.use(Vuetify);

const vuetify = new Vuetify({
  icons: {
    values: icons
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#ff7500",
        secondary: "#002767",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107"
      }
    }
  }
});

export default vuetify;
